import { registerApplication, start } from "single-spa";

window.Techyon = {};
if (window === window.parent) {
  if (!window.location.pathname.startsWith("/ui/callback")) {
    const pathname = window.location.pathname.replace("/ui/v2/", "/").replace("/ui/", "/");
    // eslint-disable-next-line no-console
    console.log("pathname", pathname);
    window.location.replace(`/ui/v3${pathname}${window.location.search}`);
  }
} else {
  const findLargest = (node) => {
    let highest = node;
    let widest = node;
    node.childNodes.forEach((childNode) => {
      const largestChildren = findLargest(childNode);
      const highestChild = largestChildren[0];
      const widestChild = largestChildren[1];

      if (
        highestChild.classList &&
        highestChild.classList.contains("chartjs-size-monitor-expand")
      ) {
        // has a height of 1000000 for some reason
        return;
      }
      if (highestChild.scrollHeight > highest.scrollHeight) {
        highest = highestChild;
      }
      if (widestChild.scrollWidth > widest.scrollWidth) {
        widest = widestChild;
      }
    });
    return [highest, widest];
  };

  const postMessage = (event, payload) => {
    window.parent.postMessage({
      source: "frame",
      app: "shell",
      event,
      payload,
    });
  };

  const html = document.getElementsByTagName("body")[0];

  new MutationObserver(() => {
    const largest = findLargest(html);
    const highest = largest[0];
    const widest = largest[1];
    postMessage("resize", { height: highest.scrollHeight, width: widest.scrollWidth });
    postMessage("href", window.location.pathname + window.location.search);
    postMessage("title", document.title);
  }).observe(html, {
    subtree: true,
    childList: true,
  });
}

const untilAuthenticated = System.import("@techyon/auth-ui").then(({ Auth }) =>
  Auth.untilAuthenticated(),
);

document.getElementsByTagName("html")[0].setAttribute("frame", "true");

registerApplication({
  name: "@techyon/app",
  app: () => untilAuthenticated.then(() => System.import("@techyon/app")),
  activeWhen: [
    "/ui/cockpit",
    "/ui/reporting",
    "/ui/meteringPoint",
    "/ui/planningCounsellor",
    "/ui/techyon",
    "/ui/testPages",
    "/ui/unhealthy-timeseries",
    "/ui/admin",
    (l) => l.pathname === "/",
  ],
});

registerApplication({
  name: "@techyon/power-state-ui",
  app: () => untilAuthenticated.then(() => System.import("@techyon/power-state-ui")),
  activeWhen: ["/ui/power-state"],
});

registerApplication({
  name: "@techyon/timeseries-ui",
  app: () => untilAuthenticated.then(() => System.import("@techyon/timeseries-ui")),
  activeWhen: ["/ui/timeseries"],
});

registerApplication({
  name: "@techyon/infrastructure-ui",
  app: () => untilAuthenticated.then(() => System.import("@techyon/infrastructure-ui")),
  activeWhen: ["/ui/infrastructure"],
});

registerApplication({
  name: "@techyon/measurements-ui",
  app: () => untilAuthenticated.then(() => System.import("@techyon/measurements-ui")),
  activeWhen: ["/ui/measurements", "/ui/v2/measurements"],
});

registerApplication({
  name: "@techyon/infrastructure-ui-v2",
  app: () => untilAuthenticated.then(() => System.import("@techyon/infrastructure-ui-v2")),
  activeWhen: ["/ui/v2/infrastructure"],
});

registerApplication({
  name: "@techyon/worklist-ui",
  app: () => untilAuthenticated.then(() => System.import("@techyon/worklist-ui")),
  activeWhen: ["/ui/v2/worklist"],
});

start();
